/**
 * Loop Subscriptions Widget
 * JavaScript for Loop subscription functionality
 */

(function() {
  'use strict';
  
  // Loop Widget Configuration
  const LoopWidget = {
    initialized: false,
    config: {
      apiEndpoint: 'https://api.loopwork.co',
      widgetVersion: '2.0',
      debug: false
    },
    
    // Initialize the widget
    init: function() {
      if (this.initialized) return;
      
      this.log('Initializing Loop Widget');
      this.bindEvents();
      this.loadWidgets();
      this.initialized = true;
    },
    
    // Bind event listeners
    bindEvents: function() {
      const toggle = document.getElementById('loop-subscription-toggle');
      const frequency = document.getElementById('loop-frequency');
      
      if (toggle) {
        toggle.addEventListener('change', this.handleSubscriptionToggle.bind(this));
      }
      
      if (frequency) {
        frequency.addEventListener('change', this.handleFrequencyChange.bind(this));
      }
    },
    
    // Handle subscription toggle
    handleSubscriptionToggle: function(event) {
      const isChecked = event.target.checked;
      const frequencySelector = document.querySelector('.loop-frequency-selector');
      const discountDisplay = document.querySelector('.loop-discount-display');
      
      if (frequencySelector) {
        frequencySelector.style.display = isChecked ? 'block' : 'none';
      }
      
      if (discountDisplay) {
        discountDisplay.style.display = isChecked ? 'block' : 'none';
      }
      
      this.updateCartProperties();
    },
    
    // Handle frequency change
    handleFrequencyChange: function(event) {
      this.updateCartProperties();
    },
    
    // Update cart properties
    updateCartProperties: function() {
      const toggle = document.getElementById('loop-subscription-toggle');
      const frequency = document.getElementById('loop-frequency');
      
      if (toggle && frequency) {
        // Update form data
        const form = document.querySelector('form[action*="/cart/add"]');
        if (form) {
          // Add subscription properties to form
          this.addHiddenInput(form, 'properties[subscription]', toggle.checked ? 'true' : '');
          this.addHiddenInput(form, 'properties[subscription_frequency]', toggle.checked ? frequency.value : '');
        }
      }
    },
    
    // Add hidden input to form
    addHiddenInput: function(form, name, value) {
      let input = form.querySelector(`input[name="${name}"]`);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        form.appendChild(input);
      }
      input.value = value;
    },
    
    // Load widgets
    loadWidgets: function() {
      const widgets = document.querySelectorAll('[data-loop-widget]');
      widgets.forEach(widget => {
        this.loadWidget(widget);
      });
    },
    
    // Load individual widget
    loadWidget: function(element) {
      this.log('Loading widget for element:', element);
      // Widget loading logic would go here
    },
    
    // Logging
    log: function(...args) {
      if (this.config.debug) {
        console.log('[Loop Widget]', ...args);
      }
    }
  };
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', LoopWidget.init.bind(LoopWidget));
  } else {
    LoopWidget.init();
  }
  
  // Expose to global scope
  window.LoopWidget = LoopWidget;
})();
